var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_4345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9635 5.20757C13.9187 5.06884 13.8341 4.94635 13.7202 4.85537C13.6063 4.76439 13.4681 4.70895 13.3229 4.69596L9.28215 4.32902L7.68433 0.589125C7.56647 0.315051 7.29817 0.137695 7.00006 0.137695C6.70195 0.137695 6.43362 0.315079 6.31582 0.589808L4.71798 4.32905L0.67655 4.69596C0.531519 4.70924 0.393577 4.7648 0.279825 4.85575C0.166074 4.94669 0.0815158 5.06902 0.0366352 5.20757C-0.0555429 5.49108 0.0295804 5.80202 0.254215 5.99802L3.30859 8.67668L2.40792 12.6441C2.34202 12.9358 2.45522 13.2374 2.69728 13.4123C2.82735 13.5063 2.97958 13.5542 3.13307 13.5542C3.26541 13.5542 3.39667 13.5185 3.51452 13.448L7.00006 11.3648L10.4843 13.448C10.7393 13.6014 11.0607 13.5874 11.3022 13.4123C11.4204 13.3267 11.5109 13.2083 11.5624 13.0717C11.6138 12.9351 11.624 12.7864 11.5916 12.6441L10.6909 8.67668L13.7453 5.99857C13.8552 5.9026 13.9344 5.77648 13.9732 5.63585C14.012 5.49522 14.0086 5.3463 13.9635 5.20757Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_4345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.110352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.55c42cde1d40c28366d9bc8293aba5a4.svg";
export { ForwardRef as ReactComponent };